<kendo-listview [data]="assigments">
    <ng-template kendoListViewHeaderTemplate>
      <div class="header">Nicht geplante Aufträge</div>
    </ng-template>
    <ng-template
      kendoListViewItemTemplate
      let-dataItem="dataItem"
      let-isFirst="isFirst"
    >
      <kendo-card 
        width="174px" 
        [attr.assigmentId]="dataItem.id" 
        [attr.title]="dataItem.title" 
        [attr.customerName]="dataItem.client?.companyName ??  dataItem.client?.firstName + ' ' + dataItem.client?.lastName" 
        class="k-card">
        <kendo-card-header class="k-hstack">
          <div>
            <h1 kendoCardTitle>{{ dataItem.title }}</h1>
            <span kendoCardSubtitle>
              {{ dataItem.internalNumber }} <br>
              <span [ngClass]="dueDateClass(dataItem.dueDate)">
                {{ dataItem.dueDate | date:'dd.MM.yyyy' }}
              </span> <br>
              {{ dataItem.client?.companyName ??  dataItem.client?.firstName + ' ' + dataItem.client?.lastName }}
            </span>
          </div>
        </kendo-card-header>
      </kendo-card>
    </ng-template>
  </kendo-listview>